// セルフ（お客様の持ち込み・受け取り）を店頭で受け付ける拠点か（2026-10-08・#613）。
// API の lpspot.self_dropoff_mode='store'（例: 白光舎 船堀店。ロッカーはUber配達員専用）。
// 店頭モードの拠点では、Uber便の注文（is_dropoff_box=1）でも、受け取りの案内は「店舗」にする。
export const spotSelfAtStore = (lpspot) => String(lpspot?.self_dropoff_mode ?? '').trim() === 'store';

// 注文の「セルフは店頭か」。
// ・セルフで預けた注文（user_dropoff_type='own'）は、注文時の記録 is_dropoff_box だけで判断する
//   （拠点の設定をあとから変えても、預け期限・自動キャンセル・ロッカー操作は注文時の記録で動くため、案内もそれに合わせる）。
// ・Uber便の注文は、受け取り（セルフ受取）の案内だけ拠点の設定に従う（店頭モードなら「店舗で受け取る」）。
export const orderSelfAtStore = (order) => {
  if (Number(order?.is_dropoff_box) === 0) return true;
  if (order?.user_dropoff_type === 'own') return false;
  return spotSelfAtStore(order?.lpspot);
};
